import React, { Component } from 'react';
import { Button, Checkbox } from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.source) {
            const { source } = this.props;

            this.state = {
                id: source.id,
                name: source.name,
                percent: source.percent,
                types: source.types,
                adult: source.adult,
                factor: source.factor,
            };
        }
        else {
            this.state = {
                name: '',
                percent: 0,
                types: [],
                adult: 0,
                factor: null,
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    handleCheckboxChange(event) {
        const { name, checked } = event.target;

        this.setState({ [name]: checked ? 1 : 0 });
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px", overflow: 'initial', position: 'fixed' }}>
                    <SelectWrap
                        value={this.state.name}
                        name="name"
                        label="Source:"
                        values={this.props.availableSources}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="percent"
                        label="Percent:"
                        onChange={this.handleFieldChange}
                        value={this.state.percent}
                        type={'number'}
                        step={'0.01'}
                        max={'100'}
                        required
                    />
                    <SelectWrap
                        value={this.state.types}
                        name="types"
                        label="Types:"
                        values={this.props.types}
                        onChange={this.handleFieldChange}
                        multi
                    />
                    <FieldGroup
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        type={'number'}
                        step={'0.01'}
                        max={'4'}
                        required
                    />
                    <Checkbox onChange={this.handleCheckboxChange} name="adult" checked={this.state.adult}>
                        Adult
                    </Checkbox>

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/BidderSources/components/Form/index.js